import React from 'react';
import { Typography, Grid, TextField, Button, Alert } from '@mui/material';
import { SimpleModal } from '@livable/saas-react-components';
import { LoaderButton } from '@livable/saas-react-components';
import useStyles from './styles';
export default function ProvidersCredentialsModal() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      size: "small",
      'custom-attribute': '170-provider-credentials-modal'
    }, "Add provider's credentials"),
    title: "Enter provider's credentials",
    noPadding: true,
    rightButton: /*#__PURE__*/React.createElement(LoaderButton, {
      loadingText: "Submitting...",
      buttonText: "Submit credentials",
      successText: "Successfully submitted",
      errorText: "Submitting failed",
      status: "success"
    })
  }, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(Alert, {
    severity: "success",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Your data is protected"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Automated: We use software, not people, to pull your data.", /*#__PURE__*/React.createElement("br", null), "Secure: We encrypt all credentials at rest and in transit.")), /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Enter your login information for your online San Francisco Public Utilities Commission (SFPUC) account:"), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Username",
    variant: "outlined",
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Password",
    variant: "outlined",
    fullWidth: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, "Forgot Username or Password? Click here")))));
}